<p>lock-group-manage-locks works!</p>
